import {reloadGridDetailContent, showDetail} from "./detail";
import {updateOneField} from "./update";
import {k1Confirm} from "../global/components/confirm";
import {fetchNewTreeData} from "./dataLoader";
import {showModalDetail} from "../global/components/modals";

export function serverSide(gridDataUrl, pageSize, maxCachedPages, modal = true, readonly = false) {
	window.gridDataUrl = gridDataUrl;

	reloadGridDetailContent();

	var gridOptions = {
		columnDefs: window.gridColumnDefinition,
		onCellDoubleClicked: showDetail,
		onCellValueChanged: updateOneField,
	};

	if (modal) {
		gridOptions.onCellDoubleClicked = showModalDetail;
	}

	if (readonly) {
		gridOptions.onCellDoubleClicked = null;
	}

	if (typeof window.getContextMenuForGrid == 'function') {
		gridOptions.getContextMenuItems = window.getContextMenuForGrid;
	}

	gridOptions.rowModelType = 'serverSide';
	gridOptions.cacheBlockSize = pageSize;
	gridOptions.maxBlocksInCache = maxCachedPages;
	gridOptions.maxConcurrentDatasourceRequests = 2;
	gridOptions.serverSideInfiniteScroll = true;
	gridOptions.blockLoadDebounceMillis = 1000;

	gridOptions.statusBar = {
		statusPanels: [
			{
				statusPanel: 'countStatusBarComponent', align: 'left'
			},
			{
				statusPanel: 'agSelectedRowCountComponent', align: 'right'
			},
		]
	}

	window.gridSettings = $.extend(window.defaultGridOptions, gridOptions);

	if (typeof window.customGridSettings == 'object') {
		window.gridSettings = $.extend(gridSettings, window.customGridSettings);
	}

	let gridContainer = document.querySelector('#ag-grid-container');

	new agGrid.Grid(gridContainer, window.gridSettings);

	gridSettings.api.setServerSideDatasource(createServerSideDataSource(gridDataUrl));
}

export function serverSideTree(gridDataUrl) {
	window.gridDataUrl = gridDataUrl;

	reloadGridDetailContent();

	var gridOptions = {
		columnDefs: window.gridColumnDefinition,
		onCellDoubleClicked: showDetail,
		onCellValueChanged: updateOneField,
		onModelUpdated: function (event) {
			event.columnApi.autoSizeAllColumns();
		},
		rowModelType: 'serverSide',
		serverSideStoreType: 'full',
		animateRows: true,
		treeData: true,
		isServerSideGroup: dataItem => {
			return dataItem.group;
		},
		getServerSideGroupKey: dataItem => {
			return dataItem.id;
		},
		getDataPath: (data) => {
			return data.parentPath;
		},
		getRowId: (params) => {
			return params.data.id;
		},
		autoGroupColumnDef: getAutoGroupColumnDef(),
		context: {
			serverSideTree: true,
		},
		onRowDragEnd: onRowDragEnd,
		onRowDragMove: onRowDragMove,
		onRowDragLeave: onRowDragLeave,
		onRowGroupOpened: function(params) {
			let id = params.data.parentPath.join('.');
			if (params.node.expanded) {
				expandedGroupIds.push(id);
			} else {
				expandedGroupIds = expandedGroupIds.filter(grpId => grpId !== id);
			}

			expandedGroupIds = [...new Set(expandedGroupIds)];
			localStorage.setItem("expandedGroupIds", JSON.stringify(expandedGroupIds));
		}
	};

	if (typeof window.getContextMenuForGrid == 'function') {
		gridOptions.getContextMenuItems = window.getContextMenuForGrid;
	}

	window.gridSettings = $.extend(window.defaultGridOptions, gridOptions);

	if (typeof window.customGridSettings == 'object') {
		window.gridSettings = $.extend(gridSettings, window.customGridSettings);
	}

	let gridContainer = document.querySelector('#ag-grid-container');
	new agGrid.Grid(gridContainer, window.gridSettings);
	window.expandedGroupIds = JSON.parse(localStorage.getItem("expandedGroupIds"));
	if (window.expandedGroupIds === null) {
		window.expandedGroupIds = [];
	}
	fetchTreeData(gridDataUrl);
}

export function createServerSideDataSource(url) {
	return {
		getRows: function (params) {
			var response = axios.post(url, params.request).then(response => {
				if (response.data.success) {
					params.api.context.totalRowCount = response.data.lastRow;
					params.successCallback(response.data.rows, response.data.lastRow);
				} else {
					params.failCallback();
				}
			});
		}
	};
}

window.createServerSideDataSource = createServerSideDataSource

export function createServerSideTreeDatasource(fakeServer) {
	return {
		getRows: (params) => {
			var allRows = fakeServer.getData(params.request);

			var request = params.request;
			var doingInfinite = request.startRow != null && request.endRow != null;
			var result = doingInfinite
				? {
					rowData: allRows.slice(request.startRow, request.endRow),
					rowCount: allRows.length,
				}
				: {rowData: allRows};
			setTimeout(function () {
				params.success(result);
			}, 200);
		},
	};
}

export function createFakeServer(fakeServerData) {
	return {
		data: fakeServerData,
		getData: function (request) {
			function extractRowsFromData(groupKeys, data) {
				if (groupKeys.length === 0) {
					return treeData(data);
				}

				var key = groupKeys[0];
				for (var i = 0; i < data.length; i++) {
					if (data[i].id === key) {
						return extractRowsFromData(
							groupKeys.slice(1),
							data[i].children.slice()
						);
					}
				}
			}

			return extractRowsFromData(request.groupKeys, this.data);
		},
	};
}

function onRowDragMove(event) {
	setPotentialParentForNode(event.api, event.overNode);
}

function onRowDragLeave(event) {
	// clear node to highlight
	setPotentialParentForNode(event.api, null);
}

function onRowDragEnd(event) {
	if (!potentialParent) {
		return;
	}

	let movingData = event.node.data;

	// take new parent path from parent, if data is missing, means it's the root node,
	// which has no data.
	let newParentPath = potentialParent.data ? potentialParent.data.parentPath : [];
	let needToChangeParent = !arePathsEqual(newParentPath, movingData.parentPath);

	// check we are not moving a folder into a child folder
	let invalidMode = isSelectionParentOfTarget(event.node, potentialParent);
	if (invalidMode) {
		console.log('invalid move');
	}

	if (needToChangeParent && !invalidMode) {
		let updatedRows = [];
		moveToPath(potentialParent, newParentPath, event.node, updatedRows);
	}

	// clear node to highlight
	setPotentialParentForNode(event.api, null);
}

function moveToPath(newParentNode, newParentPath, node, allUpdatedNodes) {
	let formData = new FormData();
	formData.append('newParentId', newParentNode.data.id);
	formData.append('categoryId', node.data.id);

	k1Confirm('Opravdu chcete přesunout větev "' + node.data.name + '" pod větev "' + newParentNode.data.name + '"?', 'Přesun kategorie')
		.then(function () {
			najaGlobal.makeRequest('POST', moveLink, formData).then((payload) => {
				if (! payload.result) {
					staticNotification.error(payload.errorMessage);
					return;
				}

				fetchNewTreeData(gridDataLink)
			}).catch((error) => {
				if ('name' in error && error.name === 'HttpError') {
					console.log(error.response);
				}
			});
		}, function () {
			console.log("Cancel")
		});
}

function isSelectionParentOfTarget(selectedNode, targetNode) {
	let children = selectedNode.childrenAfterGroup || [];
	for (let i = 0; i < children.length; i++) {
		if (targetNode && children[i].key === targetNode.key) return true;
		isSelectionParentOfTarget(children[i], targetNode);
	}
	return false;
}

function arePathsEqual(path1, path2) {
	if (path1.length !== path2.length) {
		return false;
	}

	let equal = true;
	path1.forEach(function (item, index) {
		if (path2[index] !== item) {
			equal = false;
		}
	});

	return equal;
}

function setPotentialParentForNode(api, overNode) {
	let newPotentialParent;
	newPotentialParent = overNode ? overNode : null;

	let alreadySelected = potentialParent === newPotentialParent;
	if (alreadySelected) {
		return;
	}

	// we refresh the previous selection (if it exists) to clear
	// the highlighted and then the new selection.
	let rowsToRefresh = [];
	if (potentialParent) {
		rowsToRefresh.push(potentialParent);
	}
	if (newPotentialParent) {
		rowsToRefresh.push(newPotentialParent);
	}

	potentialParent = newPotentialParent;

	refreshRows(api, rowsToRefresh);
}

function refreshRows(api, rowsToRefresh) {
	let params = {
		// refresh these rows only.
		rowNodes: rowsToRefresh,
		// because the grid does change detection, the refresh
		// will not happen because the underlying value has not
		// changed. to get around this, we force the refresh,
		// which skips change detection.
		force: true,
	};
	api.refreshCells(params);
}